<template>
    <div v-cloak v-loading="loading" element-loading-text="登录中..." class="page-wrapper">
        <swb-login-head :item="item"></swb-login-head>
        <div class="login-wrapper retail">
            <div id="login" class="logreg-banner">
                <div class="logreg-form login-fixed">
                    <h2 class="title"><a @click="switchLoginWay('acctpswd')">账号登录</a> | <a @click="switchLoginWay('scancode')">扫码登录</a></h2>
                    <div v-show="this.loginWay == 'acctpswd'">
                        <div class="msg-hint">
                            <div class="msg-warn"><i class="icon iconfont icon-gantanhao11-copy hint-icon font-red"></i> 公共场所不建议自动登录，以防账号丢失 </div>
                        </div>
                        <el-form :model="user" :rules="rules" ref="user" class="demo-ruleForm" @keyup.enter.native="submitForm('user')">
                            <div class="form-row login mb20">
                                <div class="form-value">
                                    <el-form-item prop="phoneNo">
                                        <label class="group-laber"><i class="icon iconfont icon-wode_zhanghao_dengluming font18"></i></label>
                                        <el-input v-model="user.phoneNo" class="font14" type="text" placeholder="请输入手机号码" auto-complete="off"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-row login mb20">
                                <div class="form-value">
                                    <el-form-item prop="password">
                                        <label class="group-laber"><i class="icon iconfont icon-denglu-mima font18"></i></label>
                                        <el-input v-model="user.password" class="font14" type="password" placeholder="密码" auto-complete="off"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-row login mb20">
                                <div class="form-value">
                                    <div class="fl">
                                        <label><input name="papers" type="checkbox" value=""/>
                                            <span class="ml5">自动登录</span></label>
                                    </div>
                                </div>
                            </div>
                            <el-button type="primary" @click="submitForm('user');" class="swb-btn mb20" style="width: 100%;">登录</el-button>
                        </el-form>
                    </div>
                    <div v-show="this.loginWay == 'scancode'">
                        <center>
                            <div class="msg-hint">
                                <div class="msg-warn">{{ scancodeHintText }}</div>
                            </div>
                            <img :src="scancodeImgUrl" alt="正在获取登录授权码......" width="236" height="236"/>
                        </center>
                    </div>
                    <div class="coagent">
                        <div class="fl">
                            <span>忘记密码？</span>
                            <a v-app-url="'/user/pass/reset/jsp'" class="swb-btn swb-btn-link">重置密码</a>
                        </div>
                        <div class="regist-link">
                            <a v-app-url="'/user/regist/jsp'" class="swb-btn swb-btn-link">立即注册</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <swb-login-foot></swb-login-foot>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { makeQrCodeImageUrl } from '../../app.conf'
    import comnApi from '../../api/comn'

    import userApi from '../../api/user'
    //s
    import SwbLoginHead from './Login-head';

    Vue.regist(SwbLoginHead);

    import SwbLoginFoot from './Login-foot';

    Vue.regist(SwbLoginFoot);

    export default {
        name: 'swb-login',
        desc: '用户登录',
        data: function () {
            var checkPhoneNo = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    if (value != 'sysadmin') {
                        if (!Utils.isMobileNo(value)) {
                            return callback(new Error('必须是手机号'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            };
            var validatePass = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                loading: false,
                //
                loginWay: 'acctpswd',//登录方式
                scancodeImgUrl: '',//授权登录码二维码url
                scancodeHintText: '使用商维宝App或小程序扫码登录',
                grantCode: null, //缓存的授权登录码
                scancodeTimer: null, //轮询定时器
                loginFlag: true,
                //
                item: {name: '登录', type: 'login'},
                user: {},
                rules: {
                    phoneNo: [{
                        validator: checkPhoneNo,
                        trigger: 'blur'
                    }],
                    password: [{
                        validator: validatePass,
                        trigger: 'blur'
                    }]
                }
            }
        },

        mounted: function () {
            let appMockMode = isAppMockMode();
            //
            if (appMockMode) {
                Vue.$showDialog({
                    title: "商维宝-重要公告提醒",
                    showCloseBtn: false,
                    okVisible: false,
                    cancelText: "知道了",
                    width: 600,
                    height: 300,
                    centerButtons: true,
                    template: '<div>\
                <p style="text-indent: 2em;font-size: 16px;font-weight: 600;color: red;margin-top: 10px;">亲爱的用户，为了给您提供更好的服务，我们一直在奋战！</p>\
                <p style="text-indent: 2em;font-size: 16px;font-weight: 600;color: red;margin-top: 10px;">期盼已久的功能将要发布，当前数据仅用于内部模拟验证。</p>\
                </div>',
                    data: {},
                    methods: {}
                });
            }
            // this.inputName = this.name || '请输入';
        },
        beforeDestroy: function () {
            this.stopGrantResultPulling();
        },
        methods: {
            //请求已授权的登录
            requestGrantedLogin() {
                console.info('已被授权，可以了。。。');
                //
                let self = this;
                MsgBox.loading("正在登录系统...");
                //
                comnApi.doGrantLoginAfterGranted({
                    code: self.grantCode
                }, function (result) {
                    if (result.type == 'info') {
                        console.log('已经登录成功');
                        //T跳转到其他页面
                        let redirectUrl = result.data || "/";
                        Utils.setPageUrl(getAppUrl(redirectUrl));
                    }
                    else {
                        MsgBox.hideLoading();
                        //
                        MsgBox.failure(result.message);
                    }
                });
            },
            //停止拉取授权结果
            stopGrantResultPulling() {
                clearInterval(this.scancodeTimer);
            },
            //开始拉取授权结果（轮询）
            startGrantResultPulling() {
                this.stopGrantResultPulling();
                //
                this.scancodeImgUrl = makeQrCodeImageUrl(this.grantCode, 236, 236);
                //
                let self = this;
                this.scancodeTimer = window.setInterval(function () {
                    if (self.loginWay != 'scancode') {//保险代码（消除未及时清除的定时器的影响）
                        self.stopGrantResultPulling();
                        //
                        return;
                    }
                    if (Utils.isNoB(self.grantCode)) {
                        console.error('无有效授权码');
                        //
                        self.stopGrantResultPulling();
                        //
                        return;
                    }
                    //
                    comnApi.getGrantLoginInfo({
                        code: self.grantCode
                    }, function (result) {
                        let grantInfo = null;
                        if (result.type == 'info') {
                            grantInfo = result.data;
                        }
                        if (grantInfo == null) {
                            self.scancodeHintText = "授权码已过期，请切换登录方式或刷新本页面";
                            self.stopGrantResultPulling();
                            //
                            self.grantCode = null;
                        }
                        else {
                            if (grantInfo.granted == true) {
                                self.scancodeHintText = "登录已被扫码授权";
                                self.stopGrantResultPulling();
                                //
                                self.requestGrantedLogin();
                            }
                            else {
                                self.scancodeHintText = "等待app或小程序扫码授权...";
                                console.log('继续拉取授权结果信息');
                            }
                        }
                    });
                }, 2500);
            },
            //切换登录方式
            switchLoginWay(way) {
                this.loginWay = way;
                //
                if (this.loginWay == 'scancode') {
                    if (Utils.isNoB(this.grantCode)) {
                        let self = this;
                        comnApi.renewGrantLoginCode(function (result) {
                            if (result.type == 'info') {
                                self.grantCode = result.data;
                                //
                                self.startGrantResultPulling();
                            }
                            else {
                                self.scancodeHintText = '获取登录授权码失败';
                            }
                        });
                    }
                    else {
                        this.startGrantResultPulling();
                    }
                }
                else {
                    this.stopGrantResultPulling();
                }
            },
            //
            submitForm: function (formName) {
                let self = this;
                this.$refs[formName].validate(function (valid) {
                    if (valid) {
                        self.submit();
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            submit: function () {
                let self = this;
                if (self.loginFlag == false) {
                    return false;
                }
                //
                self.loginFlag = false;
                //
                self.loading = true;
                let postData = self.user;
                userApi.doUserLogin(postData, function (result, jqXhr) {
                    //
                    if (result.type == "info") {
                        self.loginFlag = true;
                        // MsgBox.success("登录成功");
                        self.goAutoEntryTarget(result.data);
                    } else {
                        self.loading = false;
                        //
                        let options = {};
                        options.callback = function () {
                            self.loginFlag = true;
                        };
                        MsgBox.warning(result.message, options);
                    }
                });
            },
            goAutoEntryTarget: function (hrefUrl) {
                let self = this;
                userApi.getAutoLoginEntry({}, function (result, jqXhr) {
                    if (result.type == "info") {
                        // MsgBox.success("登录成功");
                        let staffRole = result.data;
                        if (staffRole != null) {
                            self.getEntryTarget(staffRole.merchantId, staffRole.comId, staffRole.roleId);
                        } else {
                            window.location.href = getAppUrl(hrefUrl);
                        }
                    } else {
                        self.loading = false;
                        MsgBox.warning(result.message);
                    }
                });
            },
            getEntryTarget: function (entityId, comId, postId) {
                let self = this;
                let postData = {};
                postData.entityId = entityId;
                postData.comId = comId;
                postData.postId = postId;
                userApi.getEntryTarget(postData, function (result) {
                    if (result.type === "info") {
                        let url = result.data;
                        window.location.href = getAppUrl(url);
                    } else {
                        self.loading = false;
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>





// WEBPACK FOOTER //
// src/compo/user/Login.vue